import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";

import Stores from "../Pages/Stores";
import City from "../Pages/City";
import Category from "../Pages/Category";
import Variants from "../Pages/Variants";
import Products from "../Pages/Products";
import StoreMenu from "../Pages/StoreMenu";
import AppSettings from "../Pages/AppSettings";
import Orders from "../Pages/Orders";
import Delivery from "../Pages/Delivery";
import RiderAvailability from "../Pages/Delivery/RiderAvailability";
import DeliveryHistory from "../Pages/Delivery/DeliveryHistory";
import Promotions from "../Pages/Promotions";
import Users from "../Pages/Users";

import Banners from "../Pages/Banners";
import Reports from "../Pages/Reports";
import PromotionPlayground from "../Pages/DeveloperTools/PromotionPlayground";
import LocationPlayground from "../Pages/DeveloperTools/LocationPlayground";
import DeliveryPlayground from "../Pages/DeveloperTools/DeliveryPlayground";
import CustomerSession from "../Pages/DeveloperTools/CustomerSession";
import OrderLifecycleSimulator from "../Pages/DeveloperTools/OrderWorkflowPlayground";
import DeliverySettings from "../Pages/Settings/DeliverySettings";
import AdminSettings from "../Pages/Settings/AdminSettings";
import Payments from "../Pages/Payments";

import Error404 from "../Pages/Utility/Error404-Page";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  { path: "/stores", component: <Stores /> },
  { path: "/cities", component: <City /> },
  { path: "/promotions", component: <Promotions /> },
  { path: "/Category", component: <Category /> },
  { path: "/variants", component: <Variants /> },
  { path: "/catalog/products", component: <Products /> },
  { path: "/app-settings", component: <AppSettings /> },
  { path: "/store/menu", component: <StoreMenu /> },
  { path: "/Orders", component: <Orders /> },
  { path: "/Orders/live", component: <Orders defaultTab="live" /> },
  { path: "/Delivery", component: <Delivery /> },
  { path: "/Delivery/Availability", component: <RiderAvailability /> },
  { path: "/Delivery/History", component: <DeliveryHistory /> },
  { path: "/users", component: <Users /> },
  {path: "/banners", component: <Banners />},
  {
    path: "/developer-tools/promotion-playground",
    component: <PromotionPlayground />,
  },
  {
    path: "/developer-tools/location-playground",
    component: <LocationPlayground />,
  },
  {
    path: "/developer-tools/delivery-playground",
    component: <DeliveryPlayground />,
  },
  {
    path: "/developer-tools/customer-session",
    component: <CustomerSession />,
  },
  {
    path: "/developer-tools/order-playground",
    component: <OrderLifecycleSimulator />,
  },
  {
    path: "/settings/delivery-settings",
    component: <DeliverySettings />,
  },
  {
    path: "/admin-settings",
    component: <AdminSettings />,
  },
  {
    path: "/payments",
    component: <Payments />,
  },
  { path: "/reports/daily-sales", component: <Reports activeTab="daily" /> },
  { path: "/reports/store-sales", component: <Reports activeTab="store" /> },
  { path: "/reports/best-sellers", component: <Reports activeTab="bestsellers" /> },
  { path: "/reports/delivery", component: <Reports activeTab="delivery" /> },
  { path: "/reports/promotion", component: <Reports activeTab="promotion" /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  {path: "*", component: <Error404 />},
];

export { authProtectedRoutes, publicRoutes };
